module.exports = __webpack_public_path__ + "static/media/epub-example-top.fce93429.png";